import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { adminAPI } from '../services/api';
import { UserCheck, LogOut } from 'lucide-react';

const InstructorLayout = ({ user, onLogout, children }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      // Call the logout API to clear authentication data
      await adminAPI.logoutAdmin();
      
      // Call the parent onLogout callback if it exists
      if (onLogout) {
        onLogout();
      }
      
      // Navigate to login page
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
      
      // Even if logout API fails, clear local data and navigate
      localStorage.removeItem('authToken');
      localStorage.removeItem('adminUser');
      sessionStorage.removeItem('authToken');
      sessionStorage.removeItem('adminUser');
      localStorage.removeItem('icer_admin_user');
      
      if (onLogout) {
        onLogout();
      }
      
      navigate('/login');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top Header */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo/Title */}
            <div className="flex items-center">
              <UserCheck className="h-8 w-8 text-blue-600 mr-3" />
              <h1 className="text-xl font-semibold text-gray-900">
                ICER Instructor Portal
              </h1>
            </div>

            {/* User Info & Logout */}
            <div className="flex items-center space-x-4">
              <div className="text-right">
                <p className="text-sm font-medium text-gray-900">
                  {user?.full_name || `${user?.first_name} ${user?.last_name}` || user?.username}
                </p>
                <p className="text-xs text-gray-500">
                  {user?.role?.charAt(0).toUpperCase() + user?.role?.slice(1)}
                </p>
              </div>
              <button
                onClick={handleLogout}
                className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
              >
                <LogOut className="h-4 w-4 mr-1" />
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <nav className="flex gap-4 mb-6" aria-label="Instructor navigation">
          <NavLink to="/instructor" className={({ isActive }) => `px-4 py-2 rounded-md ${isActive ? 'bg-blue-600 text-white' : 'bg-white text-gray-700'}`}>Миний ангиуд</NavLink>
          <NavLink to="/files" className={({ isActive }) => `px-4 py-2 rounded-md ${isActive ? 'bg-blue-600 text-white' : 'bg-white text-gray-700'}`}>Миний материал</NavLink>
        </nav>
        {children}
      </main>
    </div>
  );
};

export default InstructorLayout;
